import { ReactComponent as Component } from '@/../public/logo.svg';

export default function Logo() {
    return <Component />;
}
